import { CSVOptions, CSVProfile, CSVTranformationProfile } from "../../types";
import _ from "lodash";
import { TRANSFORM_MILLI_TO_DATE, TRANSFORM_ROUND_DECIMAL, TRANSFORM_EXCLUDE_KEY, TRANSFORM_SENTIMENTS_TO_WORDS } from "../commons/constants";
import moment from "moment";
import angular from "angular";

// export interface CSVOptions {
//     filename?: string;
//     fieldSeparator?: string;
//     quoteStrings?: string;
//     decimalSeparator?: string;
//     showLabels?: boolean;
//     showTitle?: boolean;
//     showSubTitle?: boolean;
//     title?: string;
//     subtitle?: string;
//     useTextFile?: boolean,
//     useBom?: boolean;
//     headers?: string[];
//     useKeysAsHeaders?: boolean;
// }

export class CsvConfigConsts {

    public static EOL = "\r\n";
    public static BOM = "\ufeff";

    public static DEFAULT_FIELD_SEPARATOR = ',';
    public static DEFAULT_DECIMAL_SEPARATOR = '.';
    public static DEFAULT_QUOTE = '"';
    public static DEFAULT_SHOW_TITLE = true;
    public static DEFAULT_SHOW_SUB_TITLE = true;
    public static DEFAULT_TITLE = 'Explore CSV Export';
    public static DEFAULT_SUB_TITLE = 'Explore Tab';
    public static DEFAULT_FILENAME = 'explore-csv';
    public static DEFAULT_SHOW_LABELS = true;
    public static DEFAULT_USE_TEXT_FILE = false;
    public static DEFAULT_USE_BOM = true;
    public static DEFAULT_HEADER: string[] = [];
    public static DEFAULT_KEYS_AS_HEADERS = false;

}

export const ConfigDefaults: CSVOptions = {
    filename: CsvConfigConsts.DEFAULT_FILENAME,
    fieldSeparator: CsvConfigConsts.DEFAULT_FIELD_SEPARATOR,
    quoteStrings: CsvConfigConsts.DEFAULT_QUOTE,
    decimalSeparator: CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR,
    showLabels: CsvConfigConsts.DEFAULT_SHOW_LABELS,
    showTitle: CsvConfigConsts.DEFAULT_SHOW_TITLE,
    showSubTitle: CsvConfigConsts.DEFAULT_SHOW_SUB_TITLE,
    title: CsvConfigConsts.DEFAULT_TITLE,
    subtitle: CsvConfigConsts.DEFAULT_SUB_TITLE,
    useTextFile: CsvConfigConsts.DEFAULT_USE_TEXT_FILE,
    useBom: CsvConfigConsts.DEFAULT_USE_BOM,
    headers: CsvConfigConsts.DEFAULT_HEADER,
    useKeysAsHeaders: CsvConfigConsts.DEFAULT_KEYS_AS_HEADERS,
};

export class ExportToCsv {


    private _data: any[];
    private _options: CSVOptions;
    private _csv = "";

    get options(): CSVOptions {
        return this._options;
    }

    //TODO: change objectassign to use 'prototype method Object.assign()'
    set options(options: CSVOptions) {
        this._options = objectAssign({}, ConfigDefaults, options);
    }

    constructor(options?: CSVOptions) {
        let config = options || {};

        this._options = objectAssign({}, ConfigDefaults, config);

        if (
            this._options.useKeysAsHeaders
            && this._options.headers
            && this._options.headers.length > 0
        ) {
            console.warn('Option to use object keys as headers was set, but headers were still passed!');
        }

    }

    /**
     * This method is responsible to export the Array of CSV data.
     * The array objects are represented as profiles which contains,
     * the data to be exported, cvs options and any transformation 
     * to be perform on the object key-value.
     * @param csvProfiles represent each array of data to exported
     */
    export(csvProfiles: CSVProfile[]) {
        let csvData = '';

        // iterate through each CSV export profile.
        csvProfiles.forEach(profile => {
            // set CSV options
            this.options = profile.csvOptions;

            if(profile.csvOptions.title === 'Top Keywords' || profile.csvOptions.title === 'Top Entities') {
                if(profile.data.all != undefined) {
                    profile.data.all.sort(function(a, b) {
                        return b.value - a.value
                    })
                }
            }

            if (this._options.showTitle) csvData += 'Explore - ' + this._options.title + '\r\n\n';

            // need to clone data to avoid mutation. otherwise wierd error occurs if
            // - user try to export the data again. e.g data that's already transformed
            // - will be transformed again if it's mutated.
            let dataClone = {};
            angular.copy(profile.data, dataClone);

            // perform transformations if any
            this.transformData(profile.transformationProfiles, dataClone);

            // perform CSV export
            let sources = Object.keys(dataClone);
            sources.forEach(key => {
                let data = dataClone[key];

                // set the subtitle on the global option.
                this._options = Object.assign(this._options, { subtitle: key });

                // generate the CSV data for each array data objects.
                csvData += this.generateCsv(data, true);
                csvData += '\r\n';
            });

            csvData += '\r\n';

        });

        this.createCSVFile(csvData);
    }

    /**
     * Transform the value of object based on the matching JSON key.
     * @param tranformProfiles is an array of transformation profile definition, 
     * determines what need to be done on the value of the key provided.
     * @param data is the data object to be transformed based on the profile defined.
     */
    transformData(tranformProfiles: CSVTranformationProfile[], data: any): any {
        tranformProfiles.forEach(transformProfile => {
            transform(data, transformProfile.key, transformProfile.type);
        });
    }

    /**
     * Generate CSV data from array or objects that also contains an array.
     * @param jsonData Array of objects. Note object must also be an array. e.g [ data1: [{}], data2: [{}] ]
     * @param shouldReturnCsv if true the CSV data is return otherwise file is created in browser.
     */
    generateCsvFromArrayObject(jsonData: Array<any>, shouldReturnCsv?: boolean): void | any {
        let csvData = '';

        if (this._options.showTitle) {
            csvData += 'Explore - ' + this._options.title + '\r\n\n';
        }

        // iterate through the array of object data.
        jsonData.forEach(element => {

            if (Array.isArray(element)) {
                //this._options = Object.assign(this._options, { subtitle: 'Summary' });
                csvData += this.generateCsv(element, true);

            } else {
                let sources = Object.keys(element);
                sources.forEach(key => {
                    let data = element[key];

                    // set the subtitle on the global option.
                    this._options = Object.assign(this._options, { subtitle: key });

                    // generate the CSV data for each array data objects.
                    csvData += this.generateCsv(data, true);
                    csvData += '\r\n';
                });
            }

            // append new line
            csvData += '\r\n';
        });

        // When the consumer asks for the data, exit the function
        // by returning the CSV data built at this point
        if (shouldReturnCsv) {
            return csvData;
        }

        // creates the file in the browser
        this.createCSVFile(csvData);
    }

    /**
     * Generate from array data object with option
     * to return CSV data or create a file.
     * @param jsonData is the array data
     * @param shouldReturnCsv if true the CSV data is return 
     * otherwise file is created in browser.
     */
    generateCsv(jsonData: any, shouldReturnCsv: boolean = false): void | any {

        // Make sure to reset csv data on each run
        this._csv = '';

        this._parseData(jsonData);

        if (this._options.useBom) {
            this._csv += CsvConfigConsts.BOM;
        }

        if (this._options.showSubTitle) {
            let defaultSubtitile = capitalizeFirst(this._options.subtitle);
            this._csv += (this._options.subtitle === 'all' ? 'Total' : defaultSubtitile) + '\r\n';
        }

        this._getColumnHeaders();
        this._getBody();

        if (this._csv == '') {
            console.log("Invalid data");
            return;
        }

        // When the consumer asks for the data, exit the function
        // by returning the CSV data built at this point
        if (shouldReturnCsv) {
            return this._csv;
        }

        // otherwise create the CSV file tyo be downloaded in the browser
        this.createCSVFile(this._csv);
    }

    createCSVFile(csvData: any): void {
        // Create CSV blob to download if requesting in the browser and the
        // consumer doesn't set the shouldReturnCsv param

        //encoding issue - workaround
        let BOM = "\uFEFF";
        csvData = BOM + csvData;

        const FileType = this._options.useTextFile ? 'plain' : 'csv';
        const fileExtension = this._options.useTextFile ? '.txt' : '.csv';
        let blob = new Blob([csvData], { "type": "text/" + FileType + ";charset=utf8;" });

        if (navigator.msSaveBlob) {
            let filename = this._options.filename.replace(/ /g, "_") + fileExtension;
            navigator.msSaveBlob(blob, filename);
        } else {
            const attachmentType = this._options.useTextFile ? 'text' : 'csv';
            let uri = 'data:attachment/' + attachmentType + ';charset=utf-8,' + encodeURI(csvData);
            let link = document.createElement("a");
            link.href = URL.createObjectURL(blob);

            link.setAttribute('visibility', 'hidden');
            link.download = this._options.filename.replace(/ /g, "_") + fileExtension;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    /**
     * Create Headers
     */
    private _getColumnHeaders(): void {
        if (!this._options.showLabels && !this._options.useKeysAsHeaders) {
            return;
        }
        const useKeysAsHeaders = this._options.useKeysAsHeaders;
        const headers = useKeysAsHeaders ? Object.keys(this._data[0]) : this._options.headers;

        if (headers.length > 0) {
            let row = "";
            for (let keyPos = 0; keyPos < headers.length; keyPos++) {
                row += headers[keyPos] + this._options.fieldSeparator;
            }

            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    }
    /**
     * Create Body
     */
    private _getBody() {
        const keys = Object.keys(this._data[0]);
        for (var i = 0; i < this._data.length; i++) {
            let row = "";
            for (let keyPos = 0; keyPos < keys.length; keyPos++) {
                const key = keys[keyPos];
                row += this._formatData(this._data[i][key]) + this._options.fieldSeparator;
            }

            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    }
    /**
     * Format Data
     * @param {any} data
     */
    private _formatData(data: any) {

        if (this._options.decimalSeparator === 'locale' && this._isFloat(data)) {
            return data.toLocaleString();
        }

        if (this._options.decimalSeparator !== '.' && this._isFloat(data)) {
            return data.toString().replace('.', this._options.decimalSeparator);
        }

        if (typeof data === 'string') {
            data = data.replace(/"/g, '""');
            if (this._options.quoteStrings || data.indexOf(',') > -1 || data.indexOf('\n') > -1 || data.indexOf('\r') > -1) {
                data = this._options.quoteStrings + data + this._options.quoteStrings;
            }
            return data;
        }

        if (typeof data === 'boolean') {
            return data ? 'TRUE' : 'FALSE';
        }
        return data;
    }
    /**
     * Check if is Float
     * @param {any} input
     */
    private _isFloat(input: any) {
        return +input === input && (!isFinite(input) || Boolean(input % 1));
    }
    /**
     * Parse the collection given to it
     * 
     * @private
     * @param {*} jsonData 
     * @returns {any[]} 
     * @memberof ExportToCsv
     */
    private _parseData(jsonData: any): any[] {
        this._data = typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData;

        return this._data;
    }
}

let hasOwnProperty = Object.prototype.hasOwnProperty;
let propIsEnumerable = Object.prototype.propertyIsEnumerable;

/**
 * Convet to Object
 * @param {any} val
 */
function toObject(val: any) {
    if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
}
/**
 * Assign data  to new Object
 * @param {any}   target
 * @param {any[]} ...source
 */
function objectAssign(target: any, ...source: any[]) {
    let from: any;
    let to = toObject(target);
    let symbols: any;

    for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);

        for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
            }
        }

        if ((<any>Object).getOwnPropertySymbols) {
            symbols = (<any>Object).getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                }
            }
        }
    }
    return to;
}

function capitalizeFirst(name: string) {
    return name.charAt(0).toUpperCase() + name.slice(1);
}

/********** CSV TRANSFORMATION FUNCTION ************/
function transform(dataObject, keyName, transformType) {
    if (typeof dataObject != 'object') {
        console.log('[ CSV Key Transformation ] - An invalid object was passed.');
        return null
    };

    // get the list ok keys e.g. "All, Impressessions, Retweets, Replies, e.t.c"
    let keys = Object.keys(dataObject);

    // iterate through the keys
    keys.forEach(key => {

        switch (transformType) {
            case TRANSFORM_MILLI_TO_DATE:
                Object.assign(dataObject[key],
                    dataObject[key].map(e => {
                        if (e.hasOwnProperty(keyName)) e[keyName] = formatDate(+e[keyName], 'YYYY-MM-DD HH:mm:ss');
                        return e;
                    })
                )
                break;

            case TRANSFORM_ROUND_DECIMAL:
                Object.assign(dataObject[key],
                    dataObject[key].map(e => {
                        if (e.hasOwnProperty(keyName)) e[keyName] = _.round(e[keyName], 2).toFixed(2);
                        return e;
                    })
                )
                break;

            case TRANSFORM_EXCLUDE_KEY:
                let keys = Object.keys(dataObject);
                keys.forEach(mainKey => {
                    Object.assign(dataObject[mainKey], dataObject[mainKey].filter(element => delete element[keyName]));
                });
                break;

            case TRANSFORM_SENTIMENTS_TO_WORDS:
                Object.assign(dataObject[key],
                    dataObject[key].map(e => {
                        if (e.hasOwnProperty(keyName)) e[keyName] = getSentimentWord(e[keyName]);
                        return e;
                    })
                )
                break;

            default:
                throw new Error('Uknown transformation type');
        }
    });
}


const formatDate = (dateInput: any, outputFormat: string, zone?: string) => {
    return moment(dateInput).format(outputFormat);
}

const getSentimentWord = (sentimentChar) => {
    switch (sentimentChar) {
        case 'p':
        case 'P':
            return 'Positive'
        case 'n':
        case 'N':
            return 'Neutral'
        case 'v':
        case 'V':
            return 'Negative'
        case 'u':
        case 'U':
            return 'Not Rated'
        default:
            break
    }
    return 'Unknown Sentiment Char'
}